module.exports = __webpack_public_path__ + "static/media/group4050.2d13177e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group4050.png
// module id = 1272
// module chunks = 1